import {
  Component, Output, EventEmitter, Input,
} from '@angular/core';
import { CourseFilter } from '../../courseFilter';

@Component({
  selector: 'app-course-tags-filters',
  templateUrl: './course-tags-filters.component.html',
  styleUrls: [ './course-tags-filters.component.scss' ],
})
export class CourseTagsFiltersComponent {
  @Input() mainFilter: CourseFilter;
  @Input() tagList: any;
  @Output() updateMainFilter = new EventEmitter<object>();

  constructor() { }

  checkIncludesRequirement(tag: any) {
    return !!this.mainFilter.tags.find((tagItem: any) => tag.id === tagItem.id);
  }

  updateCheckboxFilter(event: any, tag: any): void {
    const isChecked = event?.target?.checked;

    if (isChecked) {
      this.mainFilter.tags.push(tag);
    } else {
      this.mainFilter.tags = this.mainFilter.tags.filter((tagItem: any) => tagItem.id !== tag.id);
    }
  }

  selectAllTagsFilter(event: any): void {
    if (event.target.checked) {
      this.mainFilter.tags = this.tagList;
    } else {
      this.mainFilter.tags = [];
    }
  }

  clearTagsFilter(): void {
    this.mainFilter.tags = [];
  }

  getTagHelpText(tag: any): string {
    // If the tag has a description, use it
    if (tag?.description) {
      return tag.description;
    }

    // If the tag has additional info, use it
    if (tag?.additionalInfo) {
      return tag.additionalInfo;
    }

    // If the tag has details, use them
    if (tag?.details) {
      return tag.details;
    }

    // If the tag has a type, provide context
    if (tag?.type) {
      return `Show courses tagged with ${tag.type}: ${tag.tag}`;
    }

    // If the tag has a color or identifier, mention it
    if (tag?.color) {
      return `Show courses with the ${tag.tag} tag (${tag.color})`;
    }

    // If the tag has usage count, mention it
    if (tag?.usageCount) {
      return `Show courses with the ${tag.tag} tag (used in ${tag.usageCount} courses)`;
    }

    // Default fallback with tag name
    return `Show courses that have the ${tag?.tag} tag`;
  }

}
